import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../components/modal/modal.component';
import { ImagePackage, ImagePackageComments } from '../../models/image-package.model';

@Component({
  selector: 'lowy-package-comments',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <span class="link" (click)="modal.close()"><i class="material-icons">keyboard_backspace</i>cancel</span>
      <div class="headline">Package Comments for Patient {{imagePackage?.patientId}}</div>
      <div class="subheading">Leave comment, or push to Diagnosis Queue</div>

      <div *ngIf="imagePackageComments" class="subheading">
        <div *ngIf="imagePackageComments.imageComments && imagePackageComments.imageComments.length > 0">
          <p>Image Comments: <span *ngFor="let comment of imagePackageComments.imageComments"> {{comment}}, </span></p>
        </div>
        <div *ngIf="!imagePackageComments.imageComments || imagePackageComments.imageComments.length == 0">
          <p>No Image Comments.</p>
        </div>
        <div *ngIf="imagePackageComments.packageUploadComment">
          <p>Image Package Comment: {{imagePackageComments.packageUploadComment}}</p>
        </div>
        <div *ngIf="!imagePackageComments.packageUploadComment">
          <p>No Image Package Comment.</p>
        </div>
      </div>

      <mat-form-field>
        <textarea maxlength="400" matInput placeholder="Comments" [(ngModel)]="comments"></textarea>
      </mat-form-field>
      <mat-checkbox [(ngModel)]="diagnosisOverride">Push to Diagnosis Queue</mat-checkbox>

      <div class="button-row">
        <span (click)="modal.close()">cancel</span>
        <span (click)="submit()">submit</span>
      </div>
    </div>
  </lowy-modal>
  `
})
export class PackageCommentsComponent {

  @ViewChild('modal') modal: ModalComponent;

  @Output() saved: EventEmitter<any>;

  public imagePackage: ImagePackage;
  public comments: string;
  public diagnosisOverride: boolean;
  public imagePackageComments: ImagePackageComments;

  constructor() {
    this.saved = new EventEmitter();
  }

  public open(imagePackage: ImagePackage, comments: ImagePackageComments) {
    this.imagePackage = imagePackage;
    this.imagePackageComments = comments;
    this.comments = imagePackage.diagnosisOverrideComment;
    this.modal.open();
  }

  public submit() {
    this.imagePackage.diagnosisOverrideComment = this.comments;
    this.imagePackage.diagnosisOverride = this.diagnosisOverride;
    this.comments = this.diagnosisOverride = null;
    this.saved.emit(this.imagePackage);
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/reports/package-comments-modal.component.ts